import './../Input/input.css';

import * as React from 'react';

import { cn } from '@/services/utils';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const textareaBaseClassName = cn(
    `input
    bordered-input
    tw-flex
    tw-min-h-[80px]
    tw-w-full
    tw-px-3
    lg-font-dynamic
    tw-text-t-primary
    tw-py-2
    tw-text-t-sm
    disabled:tw-cursor-not-allowed
    disabled:tw-border-primary
    disabled:tw-bg-fill-secondary
    disabled:tw-text-t-inactive`
);

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, onBlur, onKeyDown, ...props }, ref) => {
        const isTabbingOutRef = React.useRef(false);

        const handleKeyDown = React.useCallback(
            (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
                if (e.key === 'Tab') {
                    isTabbingOutRef.current = true;
                }
                onKeyDown?.(e);
            },
            [onKeyDown]
        );

        const handleBlur = React.useCallback(
            (e: React.FocusEvent<HTMLTextAreaElement>) => {
                if (isTabbingOutRef.current) {
                    isTabbingOutRef.current = false;
                    window.setTimeout(() => onBlur?.(e), 0);
                    return;
                }
                onBlur?.(e);
            },
            [onBlur]
        );

        return (
            <textarea
                {...props}
                className={cn(textareaBaseClassName, className)}
                ref={ref}
                onKeyDown={handleKeyDown}
                onBlur={handleBlur}
            />
        );
    }
);

Textarea.displayName = 'Textarea';

export { Textarea };
